/**
 * Display names for the aggregators ZKX Trade quotes through. The backend sends
 * the raw id on `route.provider` (surfaced as `usedDexName`); ids not listed
 * here are shown title-cased rather than hidden.
 */
const ZKX_TRADE_AGGREGATOR_NAMES: Record<string, string> = {
  lifi: 'LI.FI',
  kyberswap: 'KyberSwap',
  zeroex: '0x',
  '0x': '0x',
  relay: 'Relay',
  oneinch: '1inch',
  '1inch': '1inch',
  paraswap: 'ParaSwap',
  openocean: 'OpenOcean',
  odos: 'Odos'
}

export const getZkxTradeAggregatorName = (dexName?: string): string | null => {
  const id = dexName?.trim()
  if (!id) return null

  return (
    ZKX_TRADE_AGGREGATOR_NAMES[id.toLowerCase()] ?? `${id.charAt(0).toUpperCase()}${id.slice(1)}`
  )
}
